var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExitFullSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1.818a.557.557 0 00-.557.557v2.376L.951.163a.557.557 0 10-.788.788l3.589 3.588H1.376a.557.557 0 000 1.114H5.1a.557.557 0 00.554-.555V1.375A.557.557 0 005.1.818zM10.792 15.07a.557.557 0 00.557-.557v-2.376l3.7 3.7a.557.557 0 00.788-.788l-3.7-3.7h2.376a.557.557 0 100-1.114h-3.722a.557.557 0 00-.557.557v3.721a.557.557 0 00.558.557zM.951 15.836l3.7-3.7v2.376a.557.557 0 101.114 0v-3.721a.557.557 0 00-.557-.557H1.486a.557.557 0 000 1.114h2.376l-3.7 3.7a.557.557 0 10.788.788zM10.903 5.654h3.721a.557.557 0 000-1.114h-2.376L15.837.951a.557.557 0 00-.788-.788l-3.588 3.589V1.376a.557.557 0 00-1.114 0v3.722a.557.557 0 00.556.556z"
  })));
}

export default SvgExitFullSize;